export default __webpack_public_path__ + "static/media/hand-hammer-blk.08bf0c98.svg";